import { CookiesProvider } from 'react-cookie';
import {
  Alert, Button, Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import useReminderNotification from './Hooks/useReminderNotification';
import StyledSnackbar from './styles';

export default function NotificationSnackbarReminder(props: { notificationPermission: string }) {
  const { notificationPermission } = props;
  const { t } = useTranslation('notifications');

  const { open, onClose } = useReminderNotification(notificationPermission);
  return (
    <CookiesProvider>
      <StyledSnackbar
        open={open}
        sx={{
          position: 'absolute', bottom: { xs: 4 }, left: { xs: 4, sm: 4 }, right: { xs: 4, sm: 4 },
        }}
        message={
          (
            <Alert severity="warning">
              <Typography>
                {t('authorize')}
              </Typography>
              <Button onClick={onClose} variant="outlined" color="warning">
                {t('reminder-tomorrow')}
              </Button>
            </Alert>
          )
        }
      />
    </CookiesProvider>
  );
}
